export { default } from './FormValidationMessage';



// WEBPACK FOOTER //
// ./src/components/atoms/FormValidationMessage/index.js